module.exports = __webpack_public_path__ + "img/audio-landscape_jp.5747d3e.jpg";